import React from 'react';
import CampoEditableNumero from '../../UI/campos/CampoEditableNumero.js';
import * as Campos from '../../constantes/Campos.js';
import styles from './CamposTorneo.module.css';

const CamposCantidadParticipantes = (props) => {
  const torneo = props.torneo;
  const editar = props.editar;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  return (
    <table className={`${styles.tablaDatos}`}>
      <tbody>
        <tr>
          <td className={`${styles.titulo}`}>Cantidad de Participantes</td>
          <td className={`${styles.valor}`}>
            <CampoEditableNumero
              estilo={`${styles.campoNumero}`}
              editar={editar}
              nombre={Campos.Torneo.CANTIDAD_PARTICIPANTES}
              valor={torneo?.cantidadParticipantes}
              largo={3}
              onChange={onCampoChange}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default CamposCantidadParticipantes;
